<article class="col-12 col-sm-6 col-md-4 post" *ngFor="let i of listChallenge">
  <a (click)="onNavigateRouter(i.id)" [ngClass]="'category-' + i">
    <span class="badge full" *ngIf="i.tag != null" [ngStyle]="{'background':i.tag.color}">{{i.tag.name}}</span>
    <h4 class="post__title small my-4" [ngStyle]="{'color':i.tag.color!= null?i.tag:'initial'}">{{i.title}}</h4>
    <p>{{i.description}}</p>
  </a>
</article>
<span class="challenge-empty"
      *ngIf="listChallenge.length === 0">{{ 'comun.registro' | translate }}</span>
